var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c8102e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.33,45.49A41.33,41.33,0,1,0,174.87,86.7a41.33,41.33,0,0,0,41.46-41.21h0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.49,168.91a6.37,6.37,0,0,0,6.37,8.21h56.42L91.64,256.79c-9,37.57,1.21,89.15,68.27,89.15H244a10.37,10.37,0,0,0,9.62-7.51l9.87-44.58a6.37,6.37,0,0,0-6.37-8.15H180.22c-18.59,0-19.1-13.75-15.73-29.1l18-79.67H281.6a10.68,10.68,0,0,0,10.06-8.21l11.85-53.18a6.37,6.37,0,0,0-6.37-8.21H68.33a10.9,10.9,0,0,0-10.06,8.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipico);
export default __webpack_public_path__ + "static/media/tipico.17a75022134cc570512f851a76764c34.svg";
export { ForwardRef as ReactComponent };